var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "page-tabs" },
        [
          _vm._l(_vm.rows, function (item, index) {
            return [
              _c(
                "a",
                {
                  key: item.index,
                  class: { active: _vm.currentTab === index },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.currentTab = index
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.title) + " ")]
              ),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "page-tabs-content" },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return _vm._l(_vm.rows, function (item, index) {
                    return _c("div", { key: item.index }, [
                      _vm.currentTab === index
                        ? _c("table", { staticClass: "table" }, [
                            _c(
                              "tbody",
                              [
                                _vm._l(item.content, function (data) {
                                  return _c("tr", { key: data.index }, [
                                    _c(
                                      "th",
                                      {
                                        staticStyle: { width: "300px" },
                                        attrs: { id: "item" },
                                      },
                                      [_vm._v(" " + _vm._s(data.Item) + " ")]
                                    ),
                                    _c(
                                      "td",
                                      [
                                        data.DataType === 0
                                          ? [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value: data.Value,
                                                    expression: "data.Value",
                                                    modifiers: { trim: true },
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { type: "text" },
                                                domProps: { value: data.Value },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      data,
                                                      "Value",
                                                      $event.target.value.trim()
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                },
                                              }),
                                            ]
                                          : _vm._e(),
                                        data.DataType === 1
                                          ? [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: { label: "true" },
                                                  model: {
                                                    value: data.Value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "Value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.Value",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n("Basic.On")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: { label: "false" },
                                                  model: {
                                                    value: data.Value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "Value",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.Value",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.i18n("Basic.Off")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        data.DataType === 3
                                          ? [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: data.Item,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                      }) {
                                                        return [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  data.Value,
                                                                expression:
                                                                  "data.Value",
                                                                modifiers: {
                                                                  number: true,
                                                                },
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            attrs: {
                                                              type: "number",
                                                              min: "1",
                                                            },
                                                            domProps: {
                                                              value: data.Value,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.$set(
                                                                  data,
                                                                  "Value",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              },
                                                            },
                                                          }),
                                                          errors[0]
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "text-danger ml-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        errors[0]
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ])
                                }),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "2" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return handleSubmit(
                                                _vm.editConfig
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.i18n("Buttons.Save")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ])
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }